import { useToastStore } from '@stores/toastStore';

const typeClasses: Record<string, string> = {
  info: 'bg-white/15 text-white',
  warning: 'bg-amber-500/20 text-amber-200',
  error: 'bg-red-500/20 text-red-200',
  success: 'bg-green-500/20 text-green-200',
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed top-4 left-1/2 z-[9999] flex -translate-x-1/2 flex-col items-center gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`animate-in fade-in slide-in-from-top-2 pointer-events-auto flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm shadow-lg backdrop-blur-md ${typeClasses[t.type ?? 'info']}`}
        >
          <span>{t.message}</span>
          {t.action && (
            <button
              type="button"
              onClick={t.action.onClick}
              className="shrink-0 rounded-lg bg-white/20 px-2.5 py-1 text-xs font-medium transition-colors hover:bg-white/30"
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
